<template>
    <div ref="mapabaselayer" id="mapaBaseLayer"  class="map-layer">
            <div v-if="mapLoaded" v-once>
                 
                 
                 <!-- <lake></lake> -->
                 <lake-polygon></lake-polygon>
                
                <!-- <lake-height-res></lake-height-res>  -->

                <percurso></percurso>

                <marker-ajr v-if="$route.meta._trackerMode != true" ></marker-ajr>
                
                <!-- <runners></runners> -->

                <threebox v-if="$route.meta._trackerMode != true" :map="map"></threebox>

            
                 <!-- <palacio-alvorada></palacio-alvorada> -->
            
            </div>
            <div class="loader" v-else>

                     <div> <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i> <br/> {{$t('Carregando')}}... </div>
            </div>
    </div>
</template>


<script>

// import mapa from './mapa.js';
    import mapBaseStyle from './styles/mapabase_style';
    import elevationControl from './iControl/elevation';

    //MAKE THREEJS and TRHEEBOX avliable on window space
    // import '../threebox-master/dist/threebox';

    //  mapboxgl.accessToken = 'pk.eyJ1IjoibGVjZWxlcyIsImEiOiJjbHR4ZHY0dHIwM3I1MnJwanRtbm1oYmI2In0.M19G6OieGBaNNoWdK8dwcQ';
     mapboxgl.accessToken = 'pk.eyJ1IjoibGVjZWxlcyIsImEiOiJjbHR4ZHY0dHIwM3I1MnJwanRtbm1oYmI2In0.M19G6OieGBaNNoWdK8dwcQ';


    export default {

            name:'mapbox',

            map:false,

            threebox:false,

            // data:function(){
            //     return {
            //         lightPosition:[ -0.5, -1, 0.55 ]
            //     }
            // },

            computed:{
                mapLoaded:function(){
                    return this.$store.state.mapLoaded;
                },
                 altimetriaVisible:function(){
                    return this.$store.state.altimetriaVisible;
                },

                map:function(){
                    return this.$options.map
                },

                threebox:function(){
                    return this.$options.threebox
                },
            },
            
            mounted() {
                    this.createMap();
                    UIEvents.$on('resizeMapContainer',()=>{
                      if(this.map) this.map.resize();
                    })
            },

            watch: {
                // call again the method if the route changes
                '$route':function (to, from) {
                    
                    if(this.mapLoaded){ //just fly if map is loaded. If not it will fly automatic when map is loaded
                        setTimeout(()=>{ 
                            this.flyToPage(to,3000)
                        },800);
                    }
                    //check for altimetria
                    if( to.path.match(/altimetria/g) ){
                        console.log("%%%%%% show altimetria")
                        this.showAltimetria()
                    }else if( from.path.match(/altimetria/g) ){
                        console.log("%%%%% saindo de altimetria %%%%%")
                        this.hideAltimetria()
                    }


                },

                altimetriaVisible:function(){
                        if(this.altimetriaVisible){
                            // alert("show altimetria")
                            this.map.addSource('mapbox-dem', {
                                'type': 'raster-dem',
                                'url': 'mapbox://mapbox.terrain-rgb',
                                'tileSize': 512,
                                'maxzoom': 14
                            });

                            // Set custom fog
                            // this.map.setFog({
                            //     'range': [-0.5, 2],
                            //     'color': '#def',
                            //     'high-color': '#def',
                            //     'space-color': '#def'
                            // });
                            // this.map.setTerrain({
                            //     'source': 'mapbox-dem',
                            //     'exaggeration': 5
                            // });
                            
                        }else{
                            // alert("hide altimetria")
                            this.map.setTerrain(null);
                            this.map.removeSource('mapbox-dem');
                        }
                }
            },


            methods:{

                createMap:function(){

                    this.$options.map = new mapboxgl.Map({
                        container: $(this.$refs.mapabaselayer)[0],
                        style: mapBaseStyle,//"mapbox://styles/leceles/cm3gg5sjq001f01r2cl0cgfdy",
             
                        hash: false,
                        antialias: true,
                        //mapBaseStyle,
                        // maxBounds: [ -48.44732177294034, -16.638275455496753, -47.22472784587998, -14.904304916348181 ]
                    });
                    window.map = this.map

                    // this.$options.map.setStyle('mapbox://styles/leceles/cm3gg5sjq001f01r2cl0cgfdy',{
                    //         sprite: window.location.origin+"/images/sprites",
                    //     })

                    
                    this.map.addControl(new mapboxgl.NavigationControl(), 'top-right');
                    this.map.addControl(new elevationControl(this.$store), 'top-right');

               
                    if(this.$dev === false){
                        this.map.jumpTo({
                            "center": _.util.inverseMercator(1865.6 / 2, 2057.6 / 2),
                            "zoom": 9,
                            "pitch": 0,
                            "bearing": -25
                        })
                    }


                    if(this.$dev){
                        // Salvar estado do mapa no localStorage
                        this.map.on('moveend', () => {
                            const mapState = {
                                center: this.map.getCenter(),
                                zoom: this.map.getZoom(),
                                pitch: this.map.getPitch(),
                                bearing: this.map.getBearing()
                            };
                            localStorage.setItem('mapState', JSON.stringify(mapState));
                        });

                        // Recuperar estado do mapa do localStorage
                        const savedMapState = localStorage.getItem('mapState');
                        if (savedMapState) {
                            const mapState = JSON.parse(savedMapState);
                            this.map.jumpTo({
                                center: mapState.center,
                                zoom: mapState.zoom,
                                pitch: mapState.pitch,
                                bearing: mapState.bearing
                            });
                        }
                    }


                    this.setMapEvents();
                },


                setMapEvents:function(){

                     this.$options.map.on('load',()=>{



                     
                     

                        setTimeout( ()=>{

                                this.$store.commit('mapLoaded',true);
                                
                                if(this.$dev){
                                    // this.flyToPage(null,5,true);
                                }else{
                                    this.flyToPage(null,5000,true);
                                }




                                

                        },1000)
                   
                   
                   
                   
                     })

                
                    // .on('moveend', ()=>{
                    //         if(this.$store.state.initialAnimationFinish == false)
                    //             this.$store.commit('initialAnimationFinish',true);
            
                    // })

                    .on('click',(e)=> {
                            //allox coords copy when click on shift.
                            //need to disable on env
                            if(event.shiftKey){
                                var coordnates = `[${e.lngLat.lng},${e.lngLat.lat}]`;
                                $("body").append(`<input id="clipboard" style="position:absolute;z-index:0;opacity:0"/>`)
                                var copyText = document.getElementById("clipboard");
                                copyText.value=coordnates;
                                /* Select the text field */
                                copyText.select();
                                /* Copy the text inside the text field */
                                document.execCommand("Copy");
                                /* Alert the copied text */
                                // alert("Copied the text: " + copyText.value);
                                $(copyText).remove();
                            }
                    })

                     .on('zoomend',(e)=> {
                                var map = e.target;
                                
                                var zoomStore =  this.$store.getters.zoom;
                                var zoomMap = map.getZoom();
                                if(zoomStore != zoomMap) 
                                    this.$store.commit("zoom",zoomMap);
                     })
                },


                showAltimetria:function(){
                    this.$store.commit('altimetriaVisible',true)
                },

                hideAltimetria:function(){
                    this.$store.commit('altimetriaVisible',false)
                },


                flyToPage:function(to, duration=2000, force=false){

                    to = to || this.$route;
                    var camera = _.get(to,'meta.camera',false);
                    var id = _.get(to,'params.id',false);

                    
                    var cameraSet = _.get(camera,id,camera);

                    if(this.$store.state.initialAnimationFinish === false)
                        cameraSet = {center:[-47.85927131478161,-15.799714225713075], pitch:55.00000000000001, zoom:12.30769269135277,bearing:0}

                    if(!cameraSet){
                        return;
                    }
debugger;
                    
                    setTimeout(()=>{ //make sure we have a delay to finish any initial setup
                        if(this.map){
                            this.map.resize(); //resize because the first time container may be change and the map note
                            //just change if it is not moving
                            if( this.map.isMoving() && force == false){
                                //   console.log("Map Moving, will not go to ");
                                 return;
                            }else{
                                // console.log("Map will fly");
                               this.map.flyTo( {...cameraSet, padding: {
      top: 20,
      bottom: 20,
      left: 600,
      right: 20
   },duration:duration})
                            }

                            //tell the map has finish it first animation
                            setTimeout( ()=>{ 
                                        if(this.$store.state.initialAnimationFinish == false)
                                             this.$store.commit('initialAnimationFinish',true);
                            },duration)
                        }
                    },100)

                }

            },


    }


</script>



<style lang="stylus">
    @import "./../css/variaveis"
  
    .loader{
        position:fixed;
        top:50%;
        left:50%;
        text-align:center;
    }

</style>
